<div class="user-management-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="user-header-info">
      <h2 class="user-name">{{ data.person.fullName }}</h2>
      <p class="user-email">{{ data.person.email }}</p>
    </div>

    <button mat-icon-button aria-label="Close" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <div class="section-header">
      <h3>Manage User</h3>
    </div>

    <div class="user-management-section">
      <div class="management-row">
        <div class="field-info">
          <!-- Figma specifies not having this info section but I think it looks better
          <label class="field-label">Group</label>
          -->
          <!-- From Chris: Readded label as it doesn't make sense to have "Deactivate User" next to admin as admin looks like a "user" and not group -->
          <div class="group-info" style="display: flex;flex-direction: row;">
            <label class="field-label">Group: </label>
            <span class="current-value">{{ edited.group }}</span>
          </div>

        </div>
        <!-- <button
        mat-raised-button
        color="primary"
        class="action-button"
        [matMenuTriggerFor]="groupMenu">
        Change Group
      </button> -->

      @if (edited.status === 'active' && !isSelf) {
        <button
          mat-raised-button
          color="warn" class="deactivate-button" [disabled]="doingAction" (click)="onDeactivate()">
          Deactivate User
        </button>
      }
      @if (edited.status === 'deactivated' && !isSelf) {
        <button
          mat-raised-button
          color="accent" class="reactivate-button" [disabled]="doingAction" (click)="onActivate()">
          Reactivate User
        </button>
      }

      @if (edited.status !== 'active' && edited.status !== 'deactivated') {
        <div class="status">
          <label class="field-label">Status: </label>
          <span class="current-value">{{ edited.status }}</span>
        </div>
      }

      <!-- Group Menu -->
      <mat-menu #groupMenu="matMenu">
        @for (group of availableGroups; track group) {
          <button
            mat-menu-item
            (click)="onGroupChange(group.name)">
            {{ group.name }}
          </button>
        }
      </mat-menu>
    </div>
  </div>
</div>

<!-- Dialog Footer -->
<div class="dialog-footer">
  <div class="footer-buttons">
    <button mat-raised-button color="primary" [disabled]="!hasUnsavedChanges() || doingAction" (click)="onSave()">
      Save
    </button>
    <button mat-stroked-button color="accent" [disabled]="doingAction" (click)="cancel()">
      Cancel
    </button>
  </div>
</div>
</div>